import Link from "next/link";
import { Col, Container, Image, Row } from "react-bootstrap";

const Page410 = () => {
	return (
		<div className="page-404-middle">
			<section className="page-404-inner">
				<Container>
					<div className="page-404-content">
						<Row>
							<Col lg={6}>
								<div className="error-page-title">
									<h1>
										<span>Opps...!</span>
										Page <u>Gone Forever</u>
									</h1>
								</div>
								<div className="error-page-content">
									<p>
										Looks like this page has bid its final
										farewell. Unlike a lost page that might
										turn up again, this one has been
										permanently removed. But don’t
										worry-your journey doesn’t have to end
										here. Let’s find a new path together!
										Head back to our homepage or explore
										other sections-you might just discover
										something even better.
									</p>
									<Link className="btn btn-primary" href="/">
										Back to Home
									</Link>
								</div>
							</Col>
							<Col lg={6}>
								<div className="error-page-img">
									<Image src="/images/410.svg" alt="404" />
								</div>
							</Col>
						</Row>
					</div>
				</Container>
			</section>
		</div>
	);
};

export default Page410;

